var _g, _circle, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettlement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10705",
    "data-name": "Group 10705",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.51,
    height: 30.447,
    viewBox: "0 0 35.51 33.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-dealing-4211704",
    transform: "translate(0 0.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7219",
    "data-name": "Path 7219",
    d: "M17.224,14.042h5.461a6.572,6.572,0,0,0,12.941,0h3.591v1.122a.494.494,0,0,0,.823.374l2.768-2.319a.491.491,0,0,0,0-.785l-2.768-2.319a.5.5,0,0,0-.823.374v1.159H35.625a6.58,6.58,0,0,0-12.941.075H17.224a.511.511,0,0,0-.524.524v1.272A.535.535,0,0,0,17.224,14.042Zm12.23-.524h-.486A2.072,2.072,0,0,1,28.556,9.4V8.582a.177.177,0,0,1,.187-.187h.935a.177.177,0,0,1,.187.187V9.4a2.032,2.032,0,0,1,1.72,1.87.177.177,0,0,1-.187.187h-.935c-.075,0-.15-.037-.15-.112a.8.8,0,0,0-.785-.673h-.524a.8.8,0,1,0-.037,1.608h.6a2.086,2.086,0,0,1,2.057,2.282,2.025,2.025,0,0,1-1.72,1.8v.823a.2.2,0,0,1-.187.187h-.935a.177.177,0,0,1-.187-.187v-.823a2.032,2.032,0,0,1-1.72-1.87.177.177,0,0,1,.187-.187H28c.075,0,.15.037.15.112a.8.8,0,0,0,.785.673h.524a.808.808,0,0,0,.823-.673A.826.826,0,0,0,29.454,13.519Z",
    transform: "translate(-11.399 -6.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7220",
    "data-name": "Path 7220",
    d: "M37.644,56.027,36.97,55.2A25.53,25.53,0,0,0,30.5,50.3l-.524.823a1.99,1.99,0,0,1-2.207.86h-.037a2.077,2.077,0,0,1-1.384-2.394,8.767,8.767,0,0,1,.9-2.319l-.785-.112a3.351,3.351,0,0,0-1.908.337l-.561.3a2.828,2.828,0,0,1-2.394.15L20.513,47.5,16.1,54.418l1.5,1.01.823-.823a1.987,1.987,0,0,1,2.768,0,1.66,1.66,0,0,1,.524,1.047,1.913,1.913,0,0,1,2.282,1.908,1.036,1.036,0,0,1-.037.337,1.969,1.969,0,0,1,1.01.486h0L25,58.42a1.934,1.934,0,0,1,.524,1.72,1.993,1.993,0,0,1,1.047.524l.037.037a1.96,1.96,0,0,1,.524,1.346,1.765,1.765,0,0,1-.374,1.122l.86,1.047a1.211,1.211,0,0,0,1.646-.037,1.16,1.16,0,0,0,.337-.823,1.207,1.207,0,0,0-.3-.785l-.374-.374a.582.582,0,0,1,.823-.823l.711.711a1.174,1.174,0,0,0,1.646,0l.037-.037a1.129,1.129,0,0,0-.037-1.608l-.785-.785a.546.546,0,0,1,0-.823.587.587,0,0,1,.823,0l1.122,1.122a1.16,1.16,0,0,0,.823.337h0a1.149,1.149,0,0,0,1.159-1.159,1.136,1.136,0,0,0-.3-.785l-1.2-1.2a.546.546,0,0,1,0-.823.587.587,0,0,1,.823,0l1.459,1.459a1.3,1.3,0,0,0,.935.374,1.16,1.16,0,0,0,.823-.337,1.207,1.207,0,0,0,.3-.785,1.877,1.877,0,0,0-.075-.449A4.872,4.872,0,0,0,37.644,56.027Z",
    transform: "translate(-11.024 -31.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7221",
    "data-name": "Path 7221",
    d: "M51.382,46.2,49.7,45.642a1.775,1.775,0,0,0-2.057.711l-.075.112a6.8,6.8,0,0,0-1.01,2.394.86.86,0,0,0,.6,1.01.836.836,0,0,0,.9-.337l.823-1.272A.545.545,0,0,1,49.362,48a.693.693,0,0,1,.262.075c.224.112,5.835,2.88,8.49,6.994l2.506-1.421-4.526-7.181A8.766,8.766,0,0,1,51.382,46.2Z",
    transform: "translate(-30.073 -30.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7222",
    "data-name": "Path 7222",
    d: "M37.082,85a.679.679,0,0,0-.524.224l-1.234,1.234a.767.767,0,0,0,1.085,1.085l1.234-1.234a.738.738,0,0,0,.224-.524.679.679,0,0,0-.224-.524A.779.779,0,0,0,37.082,85Z",
    transform: "translate(-22.917 -55.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7223",
    "data-name": "Path 7223",
    d: "M32.843,79.224A.738.738,0,0,0,32.319,79a.679.679,0,0,0-.524.224L30.224,80.8a.738.738,0,0,0-.224.524.679.679,0,0,0,.224.524.768.768,0,0,0,1.085,0l1.571-1.571A.757.757,0,0,0,32.843,79.224Z",
    transform: "translate(-19.725 -51.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7224",
    "data-name": "Path 7224",
    d: "M28.2,73.748a.741.741,0,0,0-1.272-.524l-1.908,1.908a.738.738,0,0,0-.224.524.679.679,0,0,0,.224.524.768.768,0,0,0,1.085,0l1.908-1.908A.811.811,0,0,0,28.2,73.748Z",
    transform: "translate(-16.47 -48.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7225",
    "data-name": "Path 7225",
    d: "M22.543,68.924a.738.738,0,0,0-.524-.224.679.679,0,0,0-.524.224L19.924,70.5a.738.738,0,0,0-.224.524.679.679,0,0,0,.224.524.738.738,0,0,0,.524.224h0a.679.679,0,0,0,.524-.224l1.571-1.571A.723.723,0,0,0,22.543,68.924Z",
    transform: "translate(-13.277 -45.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7226",
    "data-name": "Path 7226",
    d: "M11.157,40,9.025,38.612a.632.632,0,0,0-.374-.112H8.5a.579.579,0,0,0-.411.3L2.629,47.4a.709.709,0,0,0,.187.935l2.132,1.384a.748.748,0,0,0,.486.075.579.579,0,0,0,.411-.3l5.461-8.565A.6.6,0,0,0,11.157,40ZM4.986,48.225a.935.935,0,1,1,.935-.935A.95.95,0,0,1,4.986,48.225Z",
    transform: "translate(-2.527 -26.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7227",
    "data-name": "Path 7227",
    d: "M82.416,47.4l-5.461-8.6a.784.784,0,0,0-.411-.3h-.15a.722.722,0,0,0-.374.112L73.889,40a.66.66,0,0,0-.187.935L79.162,49.5a.784.784,0,0,0,.411.3.713.713,0,0,0,.486-.075l2.132-1.384A.683.683,0,0,0,82.416,47.4Zm-2.356.823A.935.935,0,1,1,81,47.289.977.977,0,0,1,80.06,48.225Z",
    transform: "translate(-47.007 -26.457)",
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1807",
    "data-name": "Ellipse 1807",
    cx: 5.313,
    cy: 5.313,
    r: 5.313,
    transform: "translate(11.806 2.361)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "noun-rupee-3861019",
    transform: "translate(10.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10704",
    "data-name": "Group 10704",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14547",
    "data-name": "Rectangle 14547",
    width: 15.348,
    height: 15.348,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7228",
    "data-name": "Path 7228",
    d: "M271.019,183v1.249c.73.038,2.594-.115,2.882.788h-2.882v1.114h3.017a1.827,1.827,0,0,1-1.422,1.038l-1.595.038L271,188.342l3.343,3.881h1.729l-3.151-3.862a2.842,2.842,0,0,0,2.671-2.267l1.211.038v-1.057H275.5a1.777,1.777,0,0,0-.365-.98h1.71V183Z",
    transform: "translate(-266.856 -180.125)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlement);
export default __webpack_public_path__ + "static/media/Settlement.3ac2e319887bc4a948a751c90097c399.svg";
export { ForwardRef as ReactComponent };